import TimeUnitDropdown from "components/basic/dropdowns/time-unit-dropdown/TimeUnitDropdown";
import { durationMinUnit, getValueForUnit, TIME_UNITS_TO_DAYS } from "components/basic/dropdowns/time-unit-dropdown/timeUnits";
import { InputText } from "primereact/inputtext";
import { ChronoUnit, Duration } from "@js-joda/core";
import React, { useState } from "react";
import { ColumnEditorOptions } from "primereact/column";

interface IProps {
  options: ColumnEditorOptions;
}

const IsoNumberEditor = (props: IProps) => {
  const { value, editorCallback } = props.options;

  const durationParsed = Duration.parse(value);
  const minDuration = durationMinUnit(durationParsed);

  const [durationUnit, setDurationUnit] = useState<ChronoUnit>(minDuration);
  const [durationValue, setDurationValue] = useState<number>(
    getValueForUnit(durationParsed, minDuration)
  );

  const handleChange = (currentValue: number, currentDurationUnit?: ChronoUnit) => {
    const currentUnit = currentDurationUnit ?? durationUnit;
    if (!currentUnit || !editorCallback) {
      return;
    }
    editorCallback(Duration.of(currentValue, currentUnit).toString());
  };

  return (
    <div className="p-inputgroup">
      <InputText
        type="number"
        className="w-3rem"
        value={durationValue}
        onChange={e => {
          const newValue = Number(e.target.value);
          setDurationValue(newValue);
          handleChange(newValue);
        }}
      />
      <TimeUnitDropdown
        value={durationUnit}
        className="p-inputgroup-addon p-0 w-6rem"
        options={TIME_UNITS_TO_DAYS}
        onChange={e => {
          const newUnit = e.value;
          setDurationUnit(newUnit);
          handleChange(durationValue, newUnit);
        }}
      />
    </div>
  );
};

export default IsoNumberEditor;
